"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _background = _interopRequireDefault(require("../images/onitsuka-tiger-ana/background.jpg"));

var _logoBlack = _interopRequireDefault(require("../images/onitsuka-tiger-ana/logo-black.svg"));

var _logoWhite = _interopRequireDefault(require("../images/onitsuka-tiger-ana/logo-white.svg"));

var _stitches = require("../stitches.config");

var images = {
  heroLogo: _logoWhite.default,
  brandLogo: _logoBlack.default
};
var theme = (0, _stitches.createTheme)('onitsuka-tiger-ana', {
  background: {
    image: "url(".concat(_background.default, ")")
  },
  buttonShape: {
    default: '$square'
  },
  colors: {
    inputBorder: '$grey600',
    inputBorderFocused: '$black',
    inputText: '$textBlack',
    primary: '#7f0019',
    primaryHover: '#af0022',
    textPrimary: '$textBlack'
  },
  sizes: {
    logo: '28%'
  }
});
var _default = {
  images: images,
  theme: theme
};
exports.default = _default;